/**
 * Visual components
 *
 * Pure rendering components with no interaction logic.
 * Organized by domain: canvas (SVG) and document (DOM).
 */

export * from './canvas'
export * from './document'
